export default function Footer() {
    return (
        <footer className="border-t border-[var(--background)] bg-[var(--bg)]">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-center gap-4 max-w-6xl mx-auto py-3 px-4 md:px-0">
          <div className="flex items-center gap-2.5">
            <div
              className="font-serif font-medium tracking-wide"
              style={{
                width: 20,
                height: 20,
                background:
                  "linear-gradient(135deg, #c9a96e 0%, #ddb96e 100%)",
                borderRadius: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: 12,
                color: "#0a0a0a",
              }}
            >
              t
            </div>
  
            <span className="font-serif font-medium tracking-wide text-[var(--foreground)] text-xs">
              trilfi
            </span>
          </div>
  
          <p className="font-sans font-regular tracking-wide text-[var(--foreground-muted)] text-xs">
            @2026. All rights reserved.
          </p>
        </div>
      </footer>
    );
  }